var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',_vm._b({class:[
    'py-12',
    'h-full',
    'flex flex-col items-center justify-center text-center gap-y-4',
    _vm.reduced ? '' : 'min-h-3/4'
  ]},'Container',_vm.$attrs,false),[(_vm.withLogo)?_c('Logo',{staticClass:"md:h-24 h-12"}):_vm._e(),(_vm.title)?_c('SectionTitle',{attrs:{"content":_vm.title}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }